"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _reactEmotion = _interopRequireWildcard(require("react-emotion"));

var _emotionTheming = require("emotion-theming");

var _styleConsts = require("../utils/styleConsts");

var fromTop =
/*#__PURE__*/
(0, _reactEmotion.keyframes)("from{opacity:0;transform:translateY(-100%);}to{opacity:1;transform:translateY(0);}");
var toTop =
/*#__PURE__*/
(0, _reactEmotion.keyframes)("from{opacity:1;transform:translateY(0);}to{opacity:0;transform:translateY(-100%);}");

var styles = function styles(_ref) {
  var color = _ref.theme.color,
      remove = _ref.remove;
  return (
    /*#__PURE__*/
    (0, _reactEmotion.css)("display:flex;flex-direction:row;z-index:1000;position:relative;box-sizing:border-box;margin-bottom:12px;border-radius:2px;background-color:", color.white, ";font-size:", _styleConsts.font.size.medium, ";line-height:1.36;box-shadow:0 2px 14px 0 rgba(0,0,0,0.1);font-weight:", _styleConsts.font.weight.normal, ";animation:", fromTop, " .25s ease-in-out;pointer-events:all;", remove && "\n      animation: ".concat(toTop, " .25s ease-in-out;\n  "))
  );
};

var _default = (0, _emotionTheming.withTheme)(
/*#__PURE__*/
(0, _reactEmotion.default)("section", {
  target: "css-10covkv0"
})(styles));

exports.default = _default;